// extracted by mini-css-extract-plugin
export default {"root":"wcktNdQbJ0rdEjl8fz3m","info":"o1eC_GdvezLMW5kpfmcI","iconGo":"gJ1wgyplmtIrl34P9Hpf","placeHolderShimmer":"njURlbA3o03mXojVOf_r"};